// components
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import PreferredEmployees from 'components/shared/PreferredEmployees';

// hooks
import dayjs from 'dayjs';

// types
import { PreferencesSectionProps } from './PreferencesSection.types';
import { useFormContext } from 'react-hook-form';

// utils
import { t } from 'i18next';
import { PreferredEmployeeCreatedBy } from 'components/shared/PreferredEmployees.enums';

export const PreferencesSection = ({
  selectedDate,
  selectedEmployees,
  setSelectedEmployees
}: PreferencesSectionProps) => {
  const fieldState = useFormContext().getFieldState('preferences');

  return (
    <MultiStepForm.Section
      title={t('preferences')}
      validateFields={['preferences']}
    >
      <PreferredEmployees
        date={selectedDate ? dayjs(selectedDate).toDate() : undefined}
        employees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        onlyFlex={true}
        createdBy={PreferredEmployeeCreatedBy.FLEX_PLANNER}
        disabled={!selectedDate}
        fieldState={fieldState}
      />
    </MultiStepForm.Section>
  );
};
